import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a34ce0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  viewBox: "0 0 41 311",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M-3.11543e-07 7.12728L10 4.37114e-07L10 14L-3.11543e-07 7.12728Z",
  fill: "#1A1A1A"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["mask"]
const _hoisted_7 = ["mask"]

import { getCurrentInstance, onMounted, ref, watch, onUnmounted } from "vue";

  import gsap from 'gsap'
  import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  
export default /*#__PURE__*/_defineComponent({
  props: {
    active: {
      type: Boolean
    }
  },
  setup(__props) {

const props = __props

  gsap.registerPlugin(DrawSVGPlugin);
  gsap.registerPlugin(MotionPathPlugin);


  

  const el = ref(null)
  const maskIn = ref(null)
  const maskOut = ref(null)
  const maskId = ref(null)
  const head = ref(null)
  const path = ref(null)

  let tlEnter = null as null | gsap.core.Timeline
  let tlLeave = null as null | gsap.core.Timeline

  onMounted(() => {
    maskId.value = getCurrentInstance().uid

    initEnter()
    initLeave();
    props.active && tlEnter.play();

    window.addEventListener('resize', initEnter)
  })
  onUnmounted(() => {
    window.removeEventListener('resize', initEnter)
  })

  const initEnter = () => {
    let progress = tlEnter ? tlEnter.progress() : 0

    if (tlEnter) {
      tlEnter.kill()
    }

    tlEnter = gsap.timeline({ paused: true })
      .fromTo(head.value, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 0.01,
        },
        0
      )
      .fromTo(maskIn.value, {
        drawSVG: '0 0'
      }, {
        drawSVG: '0 100%',
        duration: 1,
        ease: 'quart.out',
      }, 'start')

      .to(head.value, {
        motionPath: {
          path: maskIn.value, 
          autoRotate: 180,
          align: maskIn.value,
          alignOrigin: [1, 0.5]
        },
        duration: 1,
        ease: 'quart.out',
      }, 'start')

      .progress(progress)

    return tlEnter;
  }

  const initLeave = () => {
    tlLeave = gsap.timeline({ paused: true })
      .fromTo(maskOut.value, {
        drawSVG: '0% 100%'
      }, {
        drawSVG: '100% 100%',
        duration: 1,
        ease: 'quart.out',
      }, 'start')
  }

  watch(() => props.active, () => {
    console.log('active changed', props.active)
    if (props.active) {
      tlLeave.pause().progress(0)
      tlEnter.progress(0).play()
      console.log('enter')
    } else {
      tlLeave.progress(0).play()
      console.log('leave')
      // timeline.pause().progress(0)
    }
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["path-arrow", { 'active': __props.active }]),
    ref_key: "el",
    ref: el
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("defs", null, [
        _createElementVNode("mask", {
          id: `mask-in--${ maskId.value }`
        }, [
          _createElementVNode("path", {
            ref_key: "maskIn",
            ref: maskIn,
            d: "M34 311L34 7L10 7.00004",
            stroke: "white",
            "stroke-width": "4",
            "stroke-linejoin": "bevel"
          }, null, 512)
        ], 8, _hoisted_2),
        _createElementVNode("mask", {
          id: `mask-out--${ maskId.value }`
        }, [
          _createElementVNode("path", {
            ref_key: "maskOut",
            ref: maskOut,
            d: "M34 311L34 7L10 7.00004",
            stroke: "white",
            "stroke-width": "4",
            "stroke-linejoin": "bevel"
          }, null, 512)
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("g", {
        ref_key: "head",
        ref: head
      }, _hoisted_5, 512),
      _createElementVNode("g", {
        mask: `url(#mask-out--${ maskId.value })`
      }, [
        _createElementVNode("path", {
          ref_key: "path",
          ref: path,
          mask: `url(#mask-in--${ maskId.value })`,
          d: "M34 311L34 7L10 7.00004",
          stroke: "#1A1A1A",
          "stroke-width": "2",
          "stroke-linejoin": "bevel",
          "stroke-dasharray": "8 16"
        }, null, 8, _hoisted_7)
      ], 8, _hoisted_6)
    ]))
  ], 2))
}
}

})